namespace advisorop.domains {
    "use strict";
    export interface IProposal {
        id?: number;
        notes?: string;
        rtqId?: number;
        titleId?: number;
        accountId?: number;
        amount?: number;
        advisorFeeBillingType?: domains.FeeBillingType;
        advisorFee?: number;
        advisorFeeDescription?: string;
        accountSetupOpen?: boolean;
        timeHorizonDescription?: string;
        description?: string;
        // GL: These are currently not sent to the client
        //custodianFee?: domains.IFee;
        //platformFee?: domains.IFee;
        advisorIdCreate?: number;
        isDiscretionDocumentationOnFile?: boolean;
        timeHorizon?: number;
        dateCreate?: Date;
        dateChange?: Date;
        dateCompleted?: Date;
        advisorCreate?: domains.IAdvisor;
        advisorFullName?: string;
        title?: domains.ITitle;
        account?: domains.IAccount;
        rtq?: domains.IRTQ;
        investmentModels?: Array<domains.IProposalInvestmentModel>;
        investmentDescription?: string;
        investmentModelNames?: string;
        proposalState?: number;
        proposalStateDescription?: string;
        signedReportFileName?: string;
        riskTolerance?: domains.IRiskTolerance;
        householdReallocationItemId?: number;
        custodianAdvisoryFirmId?: number;
        custodianPricingType?: domains.PricingType;
        isOffModel?: boolean;
        previousActiveProposal?: number;
        advancedBillingInfo?: string;
    }

    export interface IAdvancedBillingInfo {
        style?: IAdvancedBillingValue;
        frequency?: IAdvancedBillingValue;
        cycleMonth?: IAdvancedBillingValue;
    }

    export interface IAdvancedBillingValue {
        value?: number;
        description?: string;
    }

    export interface IAccountProposalFees {
        proposalId: number,
        proposalDesciption: string,
        advisorFee?: number,
        accountId: number,
        accountNumber: string,
        accountName: string
    }

    export interface IProposalInvestmentModel {
        id?: number;
        //investmentModelId?: number;
        proposalId?: number;
        percentage?: number;
        amount?: number;
        managerFeeAmount?: number;
        managerFeePercentage?: number;
        //investmentModel?: domains.IInvestmentModel;

        managerProductId?: number;
        managerProductName?: string;
        productTypeId?: number;
        productTypeName?: string;
        managerId?: number;
        managerName?: string;    
    }    
}